import React from "react";
import { Swords, Loader } from "lucide-react";
import { Stat } from "./shared";

export const SallyInterrupt = ({ result, decideSally, decidingSally }) => (
  <div className="max-w-[1100px] mx-auto px-4 sm:px-8 lg:px-12 py-10 lg:py-16">
    <p className="tac-label text-[var(--danger)] fade-up">EMERGENCY // THE HUMANS SALLIED OUT</p>
    <h1 className="font-serif-h text-5xl lg:text-7xl uppercase text-bone leading-none mt-3 fade-up"
        data-testid="sally-heading">
      They charge.<br />They have nothing left to lose.
    </h1>

    <div className="grid grid-cols-3 gap-3 mt-10 fade-up delay-1">
      <Stat label="COMMITTED" value={result?.committed} />
      <Stat label="INITIAL CASUALTIES" value={result?.sally_casualties} bad />
      <Stat label="HUMAN MORALE" value={`${result?.human_morale_now}/100`} />
    </div>

    <div className="mt-10 narrative-panel fade-up delay-2">
      <p className="tac-label mb-2">DECISION</p>
      <p className="text-base text-bone leading-relaxed">
        Out of nowhere they break the encirclement and charge. Your front rank takes hits. You have seconds.
      </p>
      <p className="text-sm text-muted-h mt-4 leading-relaxed">
        <strong className="text-bone">PRESS ON</strong>: continue the battle on open ground (their fortifications are abandoned).<br />
        <strong className="text-bone">RETREAT</strong>: salvage half your remaining force. Lose half. The battle counts as defeat.
      </p>
    </div>

    <div className="flex flex-wrap gap-3 mt-8">
      <button onClick={() => decideSally(false)} disabled={decidingSally} className="btn-blood" data-testid="press-on-button">
        {decidingSally ? <Loader className="w-3 h-3 animate-spin" /> : <><Swords className="w-3 h-3" /> PRESS ON</>}
      </button>
      <button onClick={() => decideSally(true)} disabled={decidingSally} className="btn-bone" data-testid="retreat-button">
        RETREAT — LOSE HALF
      </button>
    </div>
  </div>
);
